const t = {}
t.hometab = "首页"
t.aboutUstab = "关于我们"
t.featuretab = "迈向未来"
t.contacttab = "联系我们"
t.learnMore = '了解更多';
t.aboutUs = '关于我们';
t.tellUs = "告诉我们"
t.contactUs = "联系我们"
t.transparency = "数字化"
t.standardization = "标准化"
t.informatization = "信息化"
t.ingapore = "新加坡（HQ）"
t.china = "中国"
t.greece = "希腊"
t.tel = "电话"
t.email = "邮箱"
t.name = "姓名"

t.home = {};
t.home.title = '一站式海事服务供应商';
t.home.titleSecondaryTitle = '我们为中国和新加坡所有沿海地区提供服务。';

t.home.content1Title = '我们是谁，我们能做什么';
t.home.content1SecondaryTitle = '一站式海运服务提供商';
t.home.content1P1 = "作为 Emsol Maine Service Pte Ltd (EMS)，我们提供一站式远洋轮补给服务。"
t.home.content1P2 = "我们提供全方位的船用物资，给养和保税物资。"
t.home.content1P3 = "我们还提供仓储和物流服务，运输和交付到船的备件清关服务。"
t.home.content1P4 = "我们的反应是24/7/365，致力于提供高质量的产品和高效率的服务。"

t.home.content2Title = "我们的原则"
t.home.content2SecondaryTitle = "我们始终保持初心。"
t.home.major = "专业"
t.home.innovate = "创新"
t.home.collaborate = "合作"
t.home.winwin = "共赢"
t.home.content2P1 = "我们力求把每一件事情做到最好，用我们的专业能力提供最优质服务"
t.home.content2P2 = '积极拓展多元化服务，与时俱进，开拓创新'
t.home.content2P3 = "与时俱进，在合作中共赢"
t.home.content2P4 = "坚持以客户需求为核心，服务好客户，从而成就自己"

t.home.content3Title = "我们提供的产品和服务"
t.home.content4SecondaryTitle = "我们用心 你们放心"
t.home.newShip = "新船"
t.home.material = "物料"
t.home.food = "伙食"
t.home.consumables = "消耗品"
t.home.content3P1 = "我们有一个专门的团队, 和丰富的新船供应经验为客户提供高质量的供应品和高效的服务。"
t.home.content3P2 = '通过我们广泛的供应商网络，随时随地为客户提供所需要的供应品，我们的目标是确保客户满意。'
t.home.content3P3 = "我们提供全面的新鲜、冷冻、冷藏和干燥食品，，以满足国际船员的不同偏好和需求。我们完全符合食品供应链所需的国际安全标准。"
t.home.content3P4 = "我们承诺保证质量，提供一流的服务和具有竞争力的产品价格，以满足客户需求。"
t.home.footerTitle = "我们该怎样帮助你？"

t.aboutus = {};
t.aboutus.titleSecondaryTitle = "我们为中国和新加坡所有沿海地区提供服务。"
t.aboutus.content1title = "我们的荣誉"
t.aboutus.content1SecondaryTitle = "秉承工匠精神，我们一直在努力，没有最好，只有更好"
t.aboutus.content1SecondaryTitle2 = " "

t.aboutus.content3title = "EMSOL团队"
t.aboutus.content3SecondaryTitle = "团队高管"
t.aboutus.content3P1 = "我们有一起合作，共同努力的团队精神， 唯一的目标就是更好地服务客户！"

t.feature = {};
t.feature.title = "我们才刚刚开始。";
t.feature.titleSecondaryTitle = "通过与客户的合作，我们决心创造积极的经济和社会影响-实现我们塑造杂货世界的使命"

t.feature.title1 = "迈向未来";
t.feature.titleSecondaryTitle1 = "我们正在用最新的技术来规划我们的未来。结合我们的行业经验和我们的专业态度，开发和交付最高效和灵活的运营管理系统。"

t.feature.title2 = "正在进行中的项目";
t.feature.titleSecondaryTitle2 = "我们一直在努力为您提供最贴心的服务"

t.feature.title3 = "运营管理系统";
t.feature.titleSecondaryTitle3 = "我们充分运用我们的ERP系统的数字化对我们操作的支持，帮助我们把复杂生意简单化，让流程更简便，容易操作！"

t.feature.title4 = "有什么想法想跟我们一起实现的吗？";
t.feature.titleSecondaryTitle4 = "即使你还不是客户，也要保持联系。"

t.contact = {}

t.aboutus.titleSecondaryTitleB = "我们为中国和新加坡所有沿海地区提供服务。"
t.contact.title = "迈向未来"
t.contact.titleSecondaryTitle = "我们正在用最新的技术来规划我们的未来。结合我们的行业经验和我们的专业态度，开发和交付最高效和灵活的运营管理系统。"
t.contact.title1 = "我们在哪里"
t.contact.titleSecondaryTitle1 = "目前，我们在中国和新加坡有四个办事处，分别是南通、舟山、连云港以及新加坡。我们的服务从南到北覆盖整个中国以及新加坡的主要港口。"

t.contact.title2 = "新加坡办事处"
t.contact.addess1 = "60 Paya Lebar Road #04-12,Paya Lebar Square,Singapore 409051e"

t.contact.title3 = "南通办事处"
t.contact.addess2 = "江苏省南通市港闸区永福路288号"
t.contact.title4 = "舟山办事处"
t.contact.addess3 = "浙江省舟山市定海区新港大道199号"
t.contact.title5 = "连云港办事处"
t.contact.addess4 = "江苏省连云港市东方路1号"
t.contact.title6 = "希腊代表"

export default t
